import axios from 'axios';
const baseURL = import.meta.env.VITE_Backend_URL;

// Helper function to handle 401 unauthorized errors
const handleUnauthorized = () => {
  // Clear token from localStorage
  localStorage.removeItem('lsh-token');
  // Redirect to login page
  window.location.href = '/';
};
export const getHistory = async ({ page = 1, limit = 10 } = {}) => {
  const token = localStorage.getItem('lsh-token');
  
  if (!token) {
    return null;
  }

  try {
    const response = await axios.get(`${baseURL}/api/history?page=${page}&limit=${limit}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      },
    });

    return response;
  } catch (error) {
    // Handle 401 unauthorized error
    if (error.response?.status === 401) {
      handleUnauthorized();
      return error.response;
    }
    console.error("Failed to fetch history:", error.message);
    return error.response;
  }
};